import * as Yup from "yup";

export const updateEbmSettingsSchema = Yup.object().shape({
  tin: Yup.string().required("TIN is required").matches(/^\d{9}$/, "TIN must be 9 digits"), // 9 digits
  bhfId: Yup.string().required("BHF ID is required"),
  dvcSrlNo: Yup.string().required("Device Serial Number is required"),
  ebm_activated: Yup.boolean(),
  mrc: Yup.string().required("MRC is required"),
  vat_activated: Yup.boolean(),
  topMsg: Yup.string(),
  btmMsg: Yup.string(),
});

export const updateNameSchema = Yup.object().shape({
  name: Yup.string().required("Store name is required"),
  location: Yup.string(),
  phone_number: Yup.string(),
});
